"use client";

import type { Route } from "next";
import { useRouter, usePathname, useSearchParams } from "next/navigation";

export default function useNavigationStack() {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const navStack = searchParams.get("stack")?.split(",") || [];

  const push = (page: string) => {
    const currentUrl = `${pathname}?${searchParams.toString()}`;
    const newStack = [...navStack, currentUrl];
    const [newPage, newPageParams] = page.split("?");
    const newSearchParams = new URLSearchParams(newPageParams);
    newSearchParams.set("stack", newStack.join(","));
    router.push(`${newPage}?${newSearchParams.toString()}` as Route);
  };

  const pop = (defaultUrl: string) => {
    const previousUrl = navStack.pop();

    if (previousUrl) {
      const [prevPage, prevPageParams] = previousUrl.split("?");
      const newSearchParams = new URLSearchParams(prevPageParams);
      newSearchParams.set("stack", navStack.join(","));
      router.push(`${prevPage}?${newSearchParams.toString()}` as Route);
    } else {
      router.push(defaultUrl as Route);
    }
  };

  const currentPage = navStack[navStack.length - 1];

  return { currentPage, navStack, push, pop };
}
